import React from 'react'
import PaperPanel from '../../components/PaperPanel'

function MapMarker({location, requestLocation}) {
    const {name, logo, text, status, hover, toggleHover} = location
    
    return (
        <PaperPanel 
            extraClasses={`
                mapMarker
                mapMarker-${name}
                mapMarker-${status}
                ${hover ? 'mapMarker-hover' : ''}
            `}
            onMouseEnter={() => toggleHover(name)}
            onMouseLeave={() => toggleHover(name)}
            onClick={() => requestLocation(name, status)}
        >
            <i className={`${logo} mapMarker_logo`}></i>
            <p className="mapMarker_text">{text}</p>
            <div className='mapMarker_triangle' />
        </PaperPanel>
    )
}

export default MapMarker